// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-11-07T15:16:44+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  190344
//    Project:        617
//    Environment:    7626 - master
//    MD5:            1454084009ebf6ee7da45c3ec95efae2
//    Signature:      eyJpdiI6ImRsSTNrYXFsOE5zWmdEQXVRZG5YRGc9PSIsInZhbHVlIjoiZmR3T3I5RUw0Z2ljaEkxU1dOVkJtM3A0UzVnZFB1VzNHZEx4T005cmx6K0NGdVRYOEx2WFRrTTdwZEx3bGhlU2JDYTZteUthQytiY0RqbmhMc3FFQllJT1Y3T2ZpOXlENkgzQjVaeDFZd05SZnpONnBlRHlVTDM3Vmh1XC9HM04za3Znb0EwOUlaajkzYzZwOFJuXC9SMjdYOFFjenRseGFzV2JCOU8zRG5nYm1XT3g0SmRXaWRWd21jNnV3cys4bWlNaERxenFWTG1kNVJxYjA2SkMwSTNITUZLeTRSZWVnRHlXQmEyNCtHWDBKQmltMjVKOWM4cFBUXC82N3Q0VmNLdHBMTXlXQlp2d1wvMldcL0tlTDVRTW5Wa095WEIzKzU1UTdTYTNadyt2cTlcLzNLV0F1eWVCemFQZHlORTh5TGtkampyOHJUZCs4TE9FYmxhQ3ZkMTNVK0xhclNZXC91c0dzWmtFZlZIZlBobTIwQWgyRG91bEdTbk03N1JhbFdJVmdvSXdiOG9BbU9PY0ZTTysrcnZNQjZUVWJLT2lYeFY1Z2dxYVlpa0ZicDg1RWs9IiwibWFjIjoiMmVjM2E5ZGJiZTY1ODBhZTViMGJkOTI4YmQxMDhlNTQ5YmJmMjRjYTIxZThkMjVkM2I1YjJkMmRmYTQ5NmM4YSJ9
class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
